
export default class Handler {
  constructor (options = {}) {
    this.center = new THREE.Vector2(100, 100);

    let line = this.createLine(this.center, this.center, options);
    this.element = line;
  }

  show () {
    this.element.classList.remove('invisible');
  }

  hide () {
    this.element.classList.add('invisible');
  }

  move (cx, cy) {
    this.center.set(cx, cy);
    this.rotate(cx, cy);
  }

  rotate (cx, cy) {
    const dx = cx - this.center.x;
    const dy = cy - this.center.y;

    let ndx = 0;
    let ndy = 0;
    if (Math.abs(dx) > 0 || Math.abs(dy) > 0) {
      const l = Math.sqrt(dx * dx + dy * dy);
      ndx = dx / l * 20;
      ndy = dy / l * 20;
    }

    this.element.setAttribute('x1', this.center.x + ndx);
    this.element.setAttribute('y1', this.center.y + ndy);
    this.element.setAttribute('x2', cx);
    this.element.setAttribute('y2', cy);

    const angle = Math.atan2(dx, dy);
    return angle;
  }

  createRotationPivot (center, options = {}) {
    let circle = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
    circle.setAttribute('fill', options.fill || '#000000');
    circle.setAttribute('cx', `${center.x}`);
    circle.setAttribute('cy', `${center.y}`);
    circle.setAttribute('r', '8');
    return circle;
  }

  createRotationHandler (center, options = {}) {
    let circle = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
    circle.setAttribute('stroke', options.strokeColor || '#000000');
    circle.setAttribute('stroke-width', options.strokeWidth || 2);
    circle.setAttribute('fill', 'none');
    circle.setAttribute('cx', `${center.x}`);
    circle.setAttribute('cy', `${center.y}`);
    circle.setAttribute('r', '16');
    return circle;
  }

  createLine (from, to, options = {}) {
    let line = document.createElementNS('http://www.w3.org/2000/svg', 'line');
    line.classList.add('rotation-handler');
    line.setAttribute('stroke', options.strokeColor || '#000000');
    line.setAttribute('stroke-width', options.strokeWidth || 2);
    line.setAttribute('x1', from.x);
    line.setAttribute('y1', from.y);
    line.setAttribute('x2', to.x);
    line.setAttribute('y2', to.y);
    return line;
  }
}



// WEBPACK FOOTER //
// ./src/assets/javascripts/nesting/handler.js